import React, { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ComboBox from "react-select";
import { FormField, StringField } from "cxa-form-field";
import { ACCEPT_FILES, MAX_FILE_SIZE } from "../constants";
import { renderRejectedFiles, resizeImage } from "./util";
import { change } from "redux-form";
import { injectIntl } from "react-intl";
import withMatchMediaProps from "@hocs/with-match-media-props";
import Dropzone from "../common/file-uploader/drop-zone";
import UploaderIcon from "./widgets/UploaderIcon";
import DeleteIcon from "../../assets/images/icon/delete.svg";
import PDFViewer from "./PDFViewer";
import PropTypes from "prop-types";

export const Referral = ({ referral, onDelete, allowDelete = true, selectedDelegator, isNarrowScreen }) => {
  return (
    <div>
      {allowDelete && (
        <div>
          <DeleteIcon
            onClick={onDelete}
            className="vector-icons-icon-color"
            style={{ float: "right", position: "relative", top: ".2rem", width: "1.5rem", height: "1.5rem", right: isNarrowScreen ? "11.6rem" : "4.6rem", cursor: "pointer"}}
          />
        </div>
      )}
      <div>
        {referral.type == "application/pdf" || referral.contentType == "application/pdf" ? (
          <PDFViewer
            pdfUrl={
              referral.preview ||
              (selectedDelegator
                ? `${referral.fileUrl}&selectedDelegator=${selectedDelegator}`
                : referral.fileUrl)
            }
            size="small"
          />
        ) : (
          <img
            style={{width: isNarrowScreen ? "110px" : "220px", height: isNarrowScreen ? "160px" : "254px"}}
            className="referral-image"
            src={
              selectedDelegator
                ? `${referral.fileUrl}&selectedDelegator=${selectedDelegator}`
                : referral.fileUrl || referral.preview
            }
            alt="referral letter"
          />
        )}
      </div>
    </div>
  );
};

const ReferralUploader = props => {
  const {
    uploadedFiles,
    value,
    onChange,
    onBlur,
    onDrop,
    meta,
    error,
    isNarrowScreen,
    match: { params },
    ...rest
  } = props;

  const [selectedFile, setSelectedFile] = useState(value);
  const [rejectedFiles, setRejectedFiles] = useState([]);
  const claimsData = useSelector(state => state.claimsPP);
  const dispatch = useDispatch();

  const onDelete = () => {
    setSelectedFile(null);
    setRejectedFiles([]);
    onChange(null);
  };
  const onReferralChange = item => {
    const activeFile = uploadedFiles.find(x => x.objectId == item.value);
    setSelectedFile(activeFile);
    setRejectedFiles([]);
    onChange(activeFile);
    rest.renameFieldId &&
      dispatch(change(meta.form, rest.renameFieldId, activeFile.renamedReferral));
  };

  return (
    <Fragment>
      <div style={{ marginBottom: "20px" }}>
        {uploadedFiles && uploadedFiles.length > 0 && (
          <ComboBox
            options={uploadedFiles.map(file => ({
              label: file.renamedReferral || file.fileName,
              value: file.objectId,
            }))}
            onChange={onReferralChange}
            value={selectedFile && selectedFile.objectId}
          />
        )}
      </div>
      {selectedFile ? (
        <div>
          {rest.renameFieldId && (
            <StringField
              id={rest.renameFieldId }
              name={rest.renameFieldId }
              label={rest.renameFieldName}
            />
          )}
          <Referral
            referral={selectedFile}
            onDelete={onDelete}
            selectedDelegator={params.selectedDelegator}
            isNarrowScreen={isNarrowScreen}
          />
        </div>
      ) : (
        <div className="upload-receipt-container">
          {!claimsData.isCameraStarted && (
          <Dropzone
            accept={ACCEPT_FILES}
            maxSize={MAX_FILE_SIZE}
            onDrop={(files, rejectedFiles) => {
              setRejectedFiles(rejectedFiles);
              if (rejectedFiles.length <= 0) {
                let fileItem = (files && files.length && files[0]) || {};
                let fileList = [];
                resizeImage(fileItem, fileList, fileList => {
                  if (fileList.length > 0) {
                    setSelectedFile(fileList[0]);
                    onChange(fileList[0]);
                    const fileName = fileList[0].name || "";
                    rest.renameFieldId && dispatch(change(meta.form, rest.renameFieldId, fileName));
                  }
                });
              } else {
                rest.renameFieldId && dispatch(change(meta.form, rest.renameFieldId, null));
                onChange(null);
              }
            }}
            {...rest}
          >
            <UploaderIcon size="small" />
          </Dropzone>
          )}
        </div>
      )}
      {!error && renderRejectedFiles(rejectedFiles)}
    </Fragment>
  );
};

const ReferralFieldPP = props => {
  return <FormField multiple={false} component={ReferralUploader} {...props} />;
};

Referral.propTypes = {
  referral: PropTypes.shape({
    type: PropTypes.string,
    contentType: PropTypes.string,
    preview: PropTypes.string,
    fileUrl: PropTypes.string,
  }).isRequired,
  onDelete: PropTypes.func,
  selectedDelegator: PropTypes.string,
  allowDelete: PropTypes.bool,
  isNarrowScreen: PropTypes.bool,
};

ReferralUploader.propTypes = {
  isNarrowScreen: PropTypes.shape({
    maxWidth: PropTypes.number.isRequired,
  }).isRequired,
  uploadedFiles: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onDrop: PropTypes.func,
  error: PropTypes.func,
  meta: PropTypes.shape({
    form: PropTypes.object,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
};

export default injectIntl(
  withMatchMediaProps({
    isNarrowScreen: {
      maxWidth: 680,
    },
  })(ReferralFieldPP)
);



// WEBPACK FOOTER //
// ./components/claim/ReferralFieldPP.js